import { BridgeComponent, BridgeElement } from "@hotwired/hotwire-native-bridge";

/**
 * Hands a native sheet's submit button to the shell, which draws it in the sheet's title bar
 * and replies on tap so the web button gets clicked. The footer target holds that button,
 * out of sight (overrides.css) in a shell that registers this component. The shell's button
 * follows the web one's `disabled` attribute, which Turbo sets while the form submits, and
 * goes when the page does, so a stale Save never outlives its form.
 */
export default class extends BridgeComponent {
  static component = "form";
  static targets = ["footer"];

  declare readonly footerTarget: HTMLElement;

  private observer?: MutationObserver;
  private notifyBridgeOfDisconnect = () => this.send("disconnect");

  connect() {
    super.connect();
    window.addEventListener("beforeunload", this.notifyBridgeOfDisconnect);

    const submit = this.submit;
    if (!submit) return;

    this.send("connect", { submitTitle: new BridgeElement(submit).title }, () => submit.click());
    this.observer?.disconnect();
    this.observer = new MutationObserver(() => this.send(submit.disabled ? "submitDisabled" : "submitEnabled"));
    this.observer.observe(submit, { attributes: true, attributeFilter: ["disabled"] });
  }

  disconnect() {
    window.removeEventListener("beforeunload", this.notifyBridgeOfDisconnect);
    this.observer?.disconnect();
    super.disconnect();
    this.notifyBridgeOfDisconnect();
  }

  private get submit() {
    return this.footerTarget.querySelector<HTMLButtonElement | HTMLInputElement>("[type='submit']");
  }
}
